import { getFirestore } from 'firebase/firestore';
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDd0oGfv6TGnvOrk5IsfGoMN-X5IvehZPY",
  authDomain: "typetalk-a1ed3.firebaseapp.com",
  projectId: "typetalk-a1ed3",
  storageBucket: "typetalk-a1ed3.appspot.com",
  messagingSenderId: "517639503490",
  appId: "1:517639503490:web:a91b252fca33d2dd49fe9b",
  measurementId: "G-LYYRKK9W8G"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;